import { BorderRadii } from './borderRadii';
import Colors from './colors';

export const buttonTheme = {
  primary: {
    default: {
      backgroundColor: Colors.yellow500,
      borderColor: Colors.glass900,
      textColor: Colors.glass900,
      hover: {
        backgroundColor: Colors.yellow600,
      },
      active: {
        backgroundColor: Colors.yellow600,
      },
    },
    disabled: {
      backgroundColor: Colors.glass200,
      borderColor: Colors.glass300,
      textColor: Colors.glass600,
      hover: {
        backgroundColor: Colors.yellow600,
      },
    },
    onDark: {
      default: {
        borderColor: Colors.gray3,
        backgroundColor: Colors.gray3,
        textColor: Colors.purple9,
        hover: {
          backgroundColor: Colors.yellow600,
        },
      },
      disabled: {
        borderColor: Colors.white,
        backgroundColor: Colors.white,
        textColor: Colors.gray7,
        hover: {
          backgroundColor: Colors.yellow600,
        },
      },
    },
  },
  secondary: {
    default: {
      backgroundColor: Colors.transparent,
      borderColor: Colors.glass900,
      textColor: Colors.glass900,
      hover: {
        backgroundColor: Colors.glass100,
      },
      active: {
        backgroundColor: Colors.glass200,
      },
    },
    disabled: {
      backgroundColor: Colors.transparent,
      borderColor: Colors.glass300,
      textColor: Colors.glass600,
      hover: {
        backgroundColor: Colors.transparent,
      },
    },
    onDark: {
      default: {
        borderColor: Colors.white,
        backgroundColor: Colors.transparent,
        textColor: Colors.white,
        hover: {
          backgroundColor: Colors.transparent,
        },
      },
      disabled: {
        borderColor: Colors.gray6,
        backgroundColor: Colors.transparent,
        textColor: Colors.gray6,
        hover: {
          backgroundColor: Colors.transparent,
        },
      },
    },
  },
  text: {
    default: {
      backgroundColor: Colors.transparent,
      borderColor: Colors.transparent,
      textColor: Colors.blueberry,
    },
    destructive: {
      backgroundColor: Colors.transparent,
      borderColor: Colors.transparent,
      textColor: Colors.redish,
    },
  },
  borderFocusColor: Colors.blue600,
  borderRadius: {
    default: BorderRadii.radius24,
    rounded: BorderRadii.radius24,
  },
  borderWidth: 1,
};
